var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12.1755 11.1484C11.3552 11.6611 10.8972 12.1807 10.8904 13.8828V14.0332H12.6951V13.8828C12.7019 12.9258 13.0437 12.4814 13.8162 12.0234C14.7117 11.4834 15.2927 10.7725 15.2927 9.64453C15.2927 7.95605 13.946 6.96484 12.0388 6.96484C10.2888 6.96484 8.86011 7.8877 8.82593 9.80859H10.7673C10.7947 9.00879 11.3894 8.58496 12.0251 8.57812C12.6882 8.58496 13.2214 9.0293 13.2146 9.71289C13.2214 10.3418 12.7634 10.7656 12.1755 11.1484ZM11.8337 14.8398C11.1912 14.833 10.6716 15.3457 10.6853 15.9746C10.6716 16.6104 11.1912 17.123 11.8337 17.123C12.4421 17.123 12.9685 16.6104 12.9685 15.9746C12.9685 15.3457 12.4421 14.833 11.8337 14.8398Z",
    fill: "#181A1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.2354bf64cf4efd6e0eb5d93d61a57351.svg";
export { ForwardRef as ReactComponent };